var map = {
	"./article-icon.png": "eM4U",
	"./article-sort-icon.png": "tfb0",
	"./assembly-goods-icon.png": "6yFS",
	"./assembly-sort-goods-icon.png": "BQl4",
	"./back-icon.png": "HdKu",
	"./copy-icon.png": "66Qz",
	"./coupon-icon.png": "ZEKe",
	"./cube-icon.png": "TrMw",
	"./customer-service-icon.png": "16Vw",
	"./default-img.png": "8fJy",
	"./delete-icon.png": "F/ya",
	"./divider-icon.png": "qu2d",
	"./drop-icon.png": "WAaC",
	"./edit-icon.png": "ei5K",
	"./elevatorNavigation-icon.png": "WaIh",
	"./goods-search-icon.png": "6ipd",
	"./graphicNavigation-icon.png": "lI0k",
	"./hot-spot-icon.png": "+va8",
	"./imgText-sider-icon.png": "KHgb",
	"./imgText-slider-active-icon.png": "yhDH",
	"./imgText-swipe-active-icon.png": "oLva",
	"./imgText-swipe-icon.png": "miJG",
	"./imgText-two-active-icon.png": "MPbY",
	"./imgText-two-icon.png": "coCI",
	"./mobileAppoint-icon.png": "fCst",
	"./movebottom-icon.png": "c2H0",
	"./movedown-icon.png": "+sPn",
	"./movetop-icon.png": "roOG",
	"./moveup-icon.png": "DTH5",
	"./nav-img-active-icon.png": "hbMC",
	"./nav-img-icon.png": "RIIx",
	"./nav-imgText-active-icon.png": "B+VI",
	"./nav-imgText-icon.png": "UOHf",
	"./nav-text-active-icon.png": "P7N5",
	"./nav-text-icon.png": "RtB6",
	"./phone-head.png": "IJgj",
	"./pictureAdvertising-icon.png": "N4zM",
	"./play-icon.png": "fUAb",
	"./prizeDraw-icon.png": "FMt0",
	"./rich-text-icon.png": "XrWr",
	"./seckill-icon.png": "NNqD",
	"./seckill-logo.png": "H0Wg",
	"./set-icon.png": "I0P9",
	"./shop-icon.png": "wB+1",
	"./sort-shop-icon.png": "n8OJ",
	"./title-text-icon.png": "SB66",
	"./video-icon.png": "S6Mv"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "LmnQ";


//////////////////
// WEBPACK FOOTER
// ./src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/assets/images ^\.\/.*\.png$
// module id = LmnQ
// module chunks = 243